// extracted by mini-css-extract-plugin
export default {"container":"AuthCommon_container__TNnq3","title":"AuthCommon_title__AJHx1","description":"AuthCommon_description__JKcUp","input":"AuthCommon_input__gCcdG"};